@if (isVisible) {
<section [ngClass]="['status','wait','display-flex-vert']">
  @if ( !!props.label ) {
  <mat-label class="mutara-strong">
    <h2 class="mat-headline-3">{{props.label}}</h2>
  </mat-label>
  }
  @if ( !!props.description ) {
    <markdown>{{props.description}}</markdown>
  }
  <ng-container #fieldComponent></ng-container>
</section>
}